import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_combo_tipo = _resolveComponent("combo-tipo")!
  const _component_combo_lei_consideracao = _resolveComponent("combo-lei-consideracao")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.definicaoOcorrencia.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.definicaoOcorrencia.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.definicaoOcorrencia.status,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.definicaoOcorrencia.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativa")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativa")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo(s)",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_tipo, {
                          codigos: _ctx.state.codigosTipos,
                          "onUpdate:codigos": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.codigosTipos) = $event)),
                          "multipla-selecao": true
                        }, null, 8, ["codigos"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, {
                      label: "Lei/Considerações",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_lei_consideracao, {
                          codigo: _ctx.state.definicaoOcorrencia.codigoLeiConsideracao,
                          "onUpdate:codigo": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.definicaoOcorrencia.codigoLeiConsideracao) = $event))
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, {
                      label: "Descrição/Detalhes",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_editor_html, {
                          value: _ctx.state.definicaoOcorrencia.descricao,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.definicaoOcorrencia.descricao) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}